import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { addMessage, bonoBotState, setSelectedCauses, setSuggestedByBotCauses } from 'store/bonoBot/bonoBot.slice';
import { CauseType } from 'store/causes/types';
import { useSocketInstanceContext } from 'context/socketInstanceContext';

const CauseExample: React.FC<CauseType> = (cause: CauseType) => {
   const [hideExample, setHideExample] = useState(false);
   const { title, id } = cause;
   const dispatch = useAppDispatch();
   const { selectedCauses, suggestedByBotCauses, storedThreadId } = useAppSelector(bonoBotState);
   const { sendMessageToServer } = useSocketInstanceContext();

   const updateSuggestedByBotCauses = () => {
      const wasAlreadySuggested =
         suggestedByBotCauses.length > 0 ? suggestedByBotCauses.some((c) => c.id === id) : false;
      if (!wasAlreadySuggested) {
         dispatch(setSuggestedByBotCauses([...suggestedByBotCauses, cause]));
      }
   };

   const handleClickOnExample = async () => {
      dispatch(addMessage({ role: 'user', text: `Yes, I want to choose ${title} cause` }));
      sendMessageToServer(`Yes`, storedThreadId);
      // dispatch(setSelectedCauses([...selectedCauses, cause]));
      setHideExample(true);
   };

   const handleClickOnAnotherCause = () => {
      dispatch(addMessage({ role: 'user', text: `Show another cause` }));
      sendMessageToServer(`suggest another cause`, storedThreadId);
      setHideExample(true);
   };

   useEffect(() => {
      updateSuggestedByBotCauses();
   }, []);

   return hideExample ? null : (
      <Box sx={{ display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
         <Box
            onClick={handleClickOnExample}
            sx={{
               cursor: 'pointer',
               py: 1,
               px: 1.5,
               width: 'fit-content',
               backgroundColor: '#FFFFFF',
               borderRadius: '8px',
               overflow: 'hidden',
               border: '1px solid #00000010',
            }}
         >
            <Typography
               sx={{
                  color: '#333333',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '17px',
               }}
            >
               Choose {title}
            </Typography>
         </Box>
         <Box
            onClick={handleClickOnAnotherCause}
            sx={{
               cursor: 'pointer',
               py: 1,
               px: 1.5,
               width: 'fit-content',
               backgroundColor: '#FFFFFF',
               borderRadius: '8px',
               overflow: 'hidden',
               border: '1px solid #00000010',
            }}
         >
            <Typography
               sx={{
                  color: '#333333',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '17px',
               }}
            >
               Show another cause
            </Typography>
         </Box>
      </Box>
   );
};

export default CauseExample;
